import { TQuickReplyItem } from '../types/quickReply';

const QUICK_REPLY_QUESTION_MESSAGE_KIND = 'QUICK_REPLY_QUESTION' as const;

/**
 * PRIVATE chat quick-reply chips (display order 1→6).
 * Answer text/media are authored by the backend from `id`.
 */
const QUICK_REPLY_ITEMS: TQuickReplyItem[] = [
  { id: 'himitsu', suggestText: 'HIMITSUとは？', tone: 'premium' },
  { id: 'price', suggestText: '料金は？' },
  { id: 'schedule', suggestText: '直近の出勤は？' },
  { id: 'service', suggestText: 'どんなことするの？' },
  { id: 'entertainment', suggestText: '接待で使える？' },
  { id: 'private_play', suggestText: '1:1で遊びたい' },
];

export { QUICK_REPLY_ITEMS, QUICK_REPLY_QUESTION_MESSAGE_KIND };
